import React from 'react'
import Dialog from 'Components/DesignSystem/Dialog/Dialog';
import { CANCEL } from './constants';
import Button from "Components/DesignSystem/Button/Button";
import TextField from "Components/DesignSystem/TextField/TextField";

type CopyModalProps = {
    showModal: boolean;
    closeModal: () => void;
    onConfirm: () => void;
    listName: string;
    setCopyListName: (name: string) => void;
    showIndicator?: boolean;
}

/**
 * The copy-list name prompt, on the DS Dialog (2026-09-05) — the § 96-style shell
 * migration its ARS sibling got a year of sections earlier. The legacy
 * ModalContainer shell could not theme: dark mode showed a WHITE panel holding
 * dark DS controls. The shell's close routes change shape with it: outside-click
 * (the old `setOpen`) is gone — the DS Dialog's scrim is deliberately inert —
 * and Escape + the X exist now, both resolving to the same guarded close.
 *
 * § 209 — while the parent's copy is in flight (`showIndicator`; ListView's
 * `copyInProgress` — `copyListItem` catches internally and never throws, so
 * the flag always resets) the dialog is COMMITTED: the copy is not abortable,
 * and a mid-flight close would only hide the dialog while the toast + refetch
 * still land. All three routes — Cancel, X, Escape — run through `guardedClose`.
 */
const CopyModal = ({ showModal, closeModal, onConfirm, listName, setCopyListName, showIndicator = false }: CopyModalProps) => {
    const guardedClose = () => {
        if (showIndicator) return;
        closeModal();
    };

    return (
        <Dialog
            isOpen={showModal}
            onClose={guardedClose}
            title="Copy List"
            data-testid="list-copy-modal"
            footer={
                <div className="tw-flex tw-w-full tw-justify-end tw-items-center tw-gap-3">
                    <Button id="list-copy-modal-cancel-btn" data-testid="list-copy-cancel-btn" variant="secondary" disabled={showIndicator} onClick={guardedClose}>{CANCEL}</Button>
                    <Button id="list-copy-modal-submit-btn" data-testid="list-copy-submit-btn" variant="primary" loading={showIndicator} onClick={() => onConfirm()}>Create</Button>
                </div>
            }
        >
            <TextField
                label="List Name"
                value={listName}
                onChange={(val) => setCopyListName(val)}
            />
        </Dialog>
    )
}

export default CopyModal
